var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-list-stats"},[(_vm.total)?_c('span',[_vm._v(_vm._s(_vm.currentCount))]):_vm._e(),_vm._v(" "),(_vm.total)?_c('span',[_vm._v("/")]):_vm._e(),_vm._v(" "+_vm._s(_vm.total)+" "+_vm._s(_vm.text)+" shown ")])}
var staticRenderFns = []

export { render, staticRenderFns }